import React from 'react';
export function FinalCTA() {
  return <section id="final-cta" className="py-12 md:py-16 px-5 text-center relative overflow-hidden" style={{
    background: 'linear-gradient(150deg, var(--blush) 0%, var(--lilac) 60%, var(--nude-warm) 100%)'
  }} data-id="element-59">
      {/* Decorative circle */}
      <div className="absolute pointer-events-none" style={{
      width: '400px',
      height: '400px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(200,169,110,.2) 0%, transparent 65%)',
      top: '-100px',
      right: '-80px'
    }} data-id="element-60" />

      <div className="relative max-w-[640px] mx-auto px-4" data-id="element-61">
        <h2 className="font-serif font-normal max-w-[600px] mx-auto mb-3" style={{
        fontSize: 'clamp(26px, 5.5vw, 52px)',
        color: 'var(--ink)'
      }} data-id="element-62">
          ¿Cuánto tiempo más vas a entrar
          <br data-id="element-63" />a lo nuevo cargando{' '}
          <em style={{
          color: 'var(--rose-deep)',
          fontStyle: 'italic'
        }} data-id="element-64">
            lo viejo?
          </em>
        </h2>

        <p className="text-[15px] max-w-[460px] mx-auto mb-8" style={{
        color: 'var(--muted)',
        lineHeight: 1.6
      }} data-id="element-65">
          El momento perfecto no llega. Pero{' '}
          <strong style={{
          color: 'var(--ink)',
          fontWeight: 500
        }} data-id="element-66">
            vos podés decidir que es ahora
          </strong>
          .
        </p>

        <a href="https://ebookpromax.com/cart/46586630013086:1" onClick={() => {
        const fbq = (window as any).fbq;
        if (fbq) {
          fbq('track', 'AddToCart', {
            content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
            content_type: 'product',
            value: 14990,
            currency: 'CLP'
          });
        }
      }} className="inline-block font-sans font-medium text-[12px] tracking-[2.5px] uppercase py-4 px-10 rounded no-underline relative overflow-hidden transition-all duration-300 hover:-translate-y-[3px]" style={{
        background: 'linear-gradient(135deg, var(--gold), var(--gold-shine), var(--gold))',
        backgroundSize: '200% 100%',
        color: 'var(--ink)',
        boxShadow: '0 6px 28px rgba(200,169,110,.4)'
      }} data-id="element-67">
          <span className="relative z-10" data-id="element-68">Quiero sentirme liviana </span>
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,.3), transparent 60%)'
        }} data-id="element-69" />
        </a>

        <p className="mt-4 text-[14px]" style={{
        color: 'var(--ink-soft)'
      }} data-id="element-70">
          Kit completo ·{' '}
          <strong className="font-serif text-[24px]" style={{
          color: 'var(--ink)'
        }} data-id="element-71">
            $14.990
          </strong>{' '}
          · Garantía 7 días · Acceso inmediato
        </p>

        <span className="block text-[11px] tracking-[0.5px] mt-1.5" style={{
        color: 'var(--muted)'
      }} data-id="element-72">
          Ebook + Bono 1 + Bono 2 · Valor real $56.970
        </span>
      </div>
    </section>;
}